import type { LeaderboardEntry } from '../game/types';

interface Props {
  entries: LeaderboardEntry[];
  /**
   * The public id of the person holding the phone, which highlights their row.
   * Null highlights nobody.
   */
  meId: string | null;
}

/**
 * Standings, for a trip or for friends.
 *
 * Updated whenever a sync happens rather than polled: standings change slowly,
 * and a 30-second poll would burn roughly 120 requests per player per hour
 * against the free tier's daily budget.
 */
export function Leaderboard({ entries, meId }: Props) {
  if (entries.length === 0) return null;

  return (
    <ol className="leaderboard">
      {entries.map((entry, index) => (
        <li
          key={entry.publicId}
          className={entry.publicId === meId ? 'me' : undefined}
        >
          <span className="lb-rank">{index + 1}</span>
          <span className="lb-name">
            {entry.displayName}
            {entry.publicId === meId && <span className="lb-you">you</span>}
          </span>
          <span className="lb-plates">{entry.plates}</span>
          <span className="lb-score">{entry.score.toLocaleString()}</span>
        </li>
      ))}
    </ol>
  );
}
